module.exports = __webpack_public_path__ + "media/images/faces/dummy-user-ccc4ad0597b1ff737c07f29aa0bc409a.jpg";